import { cva } from 'class-variance-authority'
import { cn } from '@/lib/utils'
import {ReactNode} from "react";

const sectionVariants = cva('section', {
    variants: {
        variant: {
            default: 'bg-default-background text-default-foreground bg-background text-foreground',
            primary: 'bg-primary text-primary-foreground',
            secondary: 'bg-secondary text-secondary-foreground',
            aloevera: 'bg-aloevera text-aloevera-foreground',
            cyan: 'bg-cyan text-cyan-foreground',
            petrol: 'bg-petrol text-petrol-foreground',
            'gray-beige-light': 'text-gray-beige-light-foreground bg-gray-beige-light',
            test: 'bg-default-foreground bg-foreground'
        }
    },
    defaultVariants: {
        variant: 'default'
    }
})

const containerVariants = cva('container grid grid-cols-4 gap-x-8 lg:grid-cols-12', {
    variants: {
        padding: {
            default: 'py-12 lg:py-20',
            lg: 'py-20 lg:py-32',
            md: 'py-12 lg:py-20',
            sm: 'py-6 lg:py-12',
            xs: 'py-4 lg:py-5',
            none: ''
        },
        size: {
            default: '',
            full: 'w-full max-w-none',
            dynamic: "lg:w-full lg:max-w-none",
        },
        flow: {
            default: '',
            true: 'flow'
        },
        breakout: {
            default: '',
            true: 'grid-cols-4 px-0 sm:grid-cols-breakout-sm md:grid-cols-breakout-md lg:grid-cols-breakout-lg xl:grid-cols-breakout-xl'
        }
    },
    defaultVariants: {
        padding: 'default',
        size: 'default',
        flow: 'default'
    }
})

interface ContainerProps {
    flow: boolean | "default" | null | undefined;
    padding: "default" | "lg" | "md" | "sm" | "xs" | "none" | null | undefined;
    size?: "default" | "full" | "dynamic" | null | undefined;
    breakout?: boolean | "default" | null | undefined;
    className?: string;
    children: ReactNode;
}

const Container = ({ flow, padding, size, breakout, className, children }: ContainerProps) => {
    return <div className={cn(containerVariants({ flow, padding, size, breakout, className }))}>{children}</div>
}

interface SectionProps {
    children: ReactNode;
    variant?: "default" | "primary" | "secondary" | "aloevera" | "cyan" | "petrol" | "gray-beige-light" | "test" | null | undefined;
    name?: string;
    id: string;
    size?: "default" | "full" | "dynamic" | null | undefined;
    flow?: boolean;
    padding?: "default" | "lg" | "md" | "sm" | "xs" | "none" | null | undefined;
    breakout?: boolean;
    className?: string;
    sectionClassName?: string;
}

const Section = ({ children, variant, name, id, size, flow = true, padding, breakout = false, className, sectionClassName }: SectionProps) => {
    const sectionClasses = `${name ? name : ''}`

    return (
        <section id={id} className={cn(sectionVariants({ variant }), sectionClasses, sectionClassName)}>
            <Container flow={flow} padding={padding} size={size} breakout={breakout} className={className}>
                {children}
            </Container>
        </section>
    )
}

export { Section, Container, containerVariants }
